const initialState = {
  allOperatorsPassRevenue: [],
  operatorPassRevenueList: [],
  passRevenueUploadSheetError: "",
};
export default initialState;
